const bannerConfig = {
    list: {
        listLayout: 'BannerListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getBanner',
        listApiParamSet: {
            ip: 0,
            ca: 'mint'
          },
        deleteFunc: 'deleteBanner',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        deleteKeyName: 'b_idx',
    },

}
export default {
    methods: {
        returnBannerConfig(type) {
            return bannerConfig[type];
        }
    },
    filterConfig: {},
}
